export default [
	{
		dataIndex: 'created_at',
		key: 'created_at',
		title: 'Transaction Time',
		align: 'center',
		width: 145,
		scopedSlots: {customRender: 'datetime'}
	}, {
		key: 'customer_number',
		title: 'Customer Number',
		width: 150,
		scopedSlots: {customRender: 'customer_number'}
	}, {
		key: 'customer_name',
		title: 'Customer Name',
		width: 150,
		scopedSlots: {customRender: 'customer_name'}
	}, {
		key: 'pan',
		title: 'PAN',
		scopedSlots: {customRender: 'pan'}
	}, {
		key: 'card_acceptor_name',
		title: 'Merchant Name',
		width: 150,
		scopedSlots: {customRender: 'card_acceptor_name'}
	}, {
		key: 'account_number_merchant',
		title: 'Account Number Merchant',
		width: 150,
		scopedSlots: {customRender: 'account_number_merchant'}
	}, {
		key: 'merchant_type',
		title: 'Merchant Type',
		width: 150,
		scopedSlots: {customRender: 'merchant_type'}
	}, {
		key: 'mid',
		title: 'Merchant ID',
		scopedSlots: {customRender: 'mid'}
	}, {
		key: 'tid',
		title: 'Terminal ID',
		scopedSlots: {customRender: 'tid'}
	}, {
		key: 'batch_number',
		title: 'Batch Number',
		scopedSlots: {customRender: 'batch_number'}
	}, {
		key: 'branch_code',
		title: 'Branch Code',
		scopedSlots: {customRender: 'branch_code'}
	}, {
		key: 'stan',
		title: 'STAN',
		scopedSlots: {customRender: 'stan'}
	}, {
		key: 'rrn',
		title: 'RRN',
		scopedSlots: {customRender: 'rrn'}
	}, {
		key: 'product_name',
		title: 'Product Name',
		scopedSlots: {customRender: 'product_name'}
	}, {
		key: 'product_code',
		title: 'Product Code',
		scopedSlots: {customRender: 'product_code'}
	}, {
		key: 'billers',
		title: 'Biller',
		width: 150,
		scopedSlots: {customRender: 'biller'}
	}, {
		key: 'driver',
		title: 'Driver',
		width: 150,
		scopedSlots: {customRender: 'driver'}
	}, {
		key: 'clients',
		title: 'Client',
		width: 150,
		scopedSlots: {customRender: 'client'}
	}, {
		key: 'subscriber_id',
		title: 'Subscriber ID',
		width: 150,
		scopedSlots: {customRender: 'subscriber_id'}
	}, {
		key: 'amount',
		title: 'Amount',
		scopedSlots: {customRender: 'amount'}
	}, {
		key: 'denomination',
		title: 'Denomination',
		scopedSlots: {customRender: 'denomination'}
	}, {
		key: 'ref_number',
		title: 'Biller Ref Number',
		scopedSlots: {customRender: 'ref_number'}
	}, {
		key: 'serial_number',
		title: 'S/N',
		scopedSlots: {customRender: 'serial_number'}
	}, {
		dataIndex: 'service_type',
		key: 'service',
		title: 'Service',
		align: 'center',
		width: 80,
		scopedSlots: {customRender: 'service'}
	}, {
		key: 'biller_price',
		title: 'Bill Amount',
		align: 'center',
		width: 125,
		scopedSlots: {customRender: 'biller_price'}
	}, {
		key: 'profit',
		title: 'Profit',
		align: 'center',
		width: 88,
		scopedSlots: {customRender: 'profit'}
	}, {
		key: 'response_code',
		title: 'RC',
		scopedSlots: {customRender: 'response_code'}
	}, {
		key: 'status',
		title: 'Response',
		width: 100,
		scopedSlots: {customRender: 'status'}
	}, {
		key: 'action',
		title: '',
		width: 180,
		align: "right",
		scopedSlots: {customRender: 'action'}
	}
]
